import { render, staticRenderFns } from "./PackageOrder.vue?vue&type=template&id=105285e1&scoped=true"
import script from "./PackageOrder.vue?vue&type=script&lang=js"
export * from "./PackageOrder.vue?vue&type=script&lang=js"
import style0 from "./PackageOrder.vue?vue&type=style&index=0&id=105285e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105285e1",
  null
  
)

export default component.exports